import get from 'lodash/get';
import { useQuery } from '@apollo/client/react';
import { LastProjectDocument } from 'graphql/generated/graphql';

const useLastProjectId = () => {
  const { data, loading } = useQuery(LastProjectDocument);
  const lastProjectId = get(data, 'lastProject._id', null);

  return { lastProjectId, loading };
};

export default useLastProjectId;
